import React from "react";
import Accordion from "react-bootstrap/Accordion";
import { formatDateTimezon } from "../../common-data/Converts";
import PaginationModified from "../../../data/PaginationModified";
import {
  CheckCircleIcon,
  CrossCircleIcon,
  EyeIcon,
} from "../../../images/icons/icons";

const RecurringSubsListingsMobile = ({
  tableData,
  tablePagination,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
}) => {
  function getPagination() {
    try {
      const pagination = tablePagination ? tablePagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="all-leads-log mt30">
      {tableData?.length > 0 &&
        tableData.map((row, index) => {
          const isAddedToLMS = row?.added_to_lead;

          const dateTime = row?.date_added ? row.date_added.split(" ") : null;
          const datePart = dateTime ? dateTime[0] : "-";
          const timePart = dateTime ? dateTime[1] + " " + dateTime[2] : "-";

          const sourceName =
            row?.source_name.replace(/ /g, "_").toLowerCase() ===
            "wtf_one_day_plan"
              ? "WTF One Day Plan"
              : row?.source_name?.replace(/_/g, " ");

          return (
            <div className="log-card" key={index}>
              <div className="all-info">
                <div className="log-card-top">
                  <h3 className="lead-name">{row?.name || "NA"}</h3>

                  <button
                    className="lead-log view-lead"
                    type="button"
                    style={{
                      minWidth: "120px",
                      background: isAddedToLMS ? "#000" : "#C90808",
                      color: "#fff",
                      borderRadius: "8px",
                      cursor: "pointer",
                      fontSize: "15px",
                      padding: "10px",
                      border: "none",
                    }}
                    onClick={() =>
                      setModValues((prevs) => ({
                        ...prevs,
                        isModOpen: true,
                        rowData: row,
                        modName: isAddedToLMS ? "view-lead-journey" : "add-to-lead",
                      }))
                    }
                  >
                    {isAddedToLMS ? "View Lead" : "Add To LMS"}
                  </button>
                </div>

                <div className="card-other-info">
                  <span className="value semi-bold">{row?.mobile || "NA"}</span>
                  {row?.email ? (
                    <span className="value email semi-bold">
                      {row.email || ""}
                    </span>
                  ) : null}
                  <span className="value semi-bold">
                    {row?.gym_name || "NA"}
                  </span>
                </div>

                <div className="all-followuo-info-container">
                  <Accordion>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        <div className="heade-info">
                          <span className="title">date added</span>
                          <span className="value">
                            {datePart} {timePart}
                          </span>
                        </div>
                      </Accordion.Header>

                      <Accordion.Body>
                        <div className="lead-multi-value-cols px20px pb20px">
                          <div className="label-value">
                            <span className="label">Start Date</span>
                            <span className="value">
                              {row?.start_date
                                ? formatDateTimezon(row.start_date)
                                : "-"}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">Expire Date</span>
                            <span className="value">
                              {row?.expire_date
                                ? formatDateTimezon(row.expire_date)
                                : ""}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">Subscription Status</span>
                            <span className="value icon">
                              {row?.is_payment_done ? (
                                <CheckCircleIcon />
                              ) : (
                                <CrossCircleIcon />
                              )}
                            </span>
                          </div>

                          <div className="label-value flex-col">
                            <span className="label">source name</span>
                            <span
                              className={`value ${
                                row?.utm_source ? "link" : ""
                              }`}
                              onClick={() =>
                                row?.utm_source &&
                                setModValues({
                                  isModOpen: true,
                                  modName: "UTM_parameters",
                                  rawLeadId: row?.uid,
                                  rowData: row,
                                })
                              }
                            >
                              {sourceName || "NA"}
                            </span>
                          </div>

                          <div className="label-value flex-col">
                            <span className="label">city</span>
                            <span className="value">{row?.city || "NA"}</span>
                          </div>

                          <div className="label-value flex-col">
                            <span className="label">preferred slot</span>
                            <span className="value">
                              {row?.preferred_slot || "-"}
                            </span>
                          </div>

                          <div className="label-value flex-col">
                            <span className="label">Added to LMS</span>
                            <span className="value">
                              {row?.added_on_lead
                                ? formatDateTimezon(row.added_on_lead)
                                : "-"}
                              <br />
                              <small className="gray underline">
                                {row?.add_to_lms_time_dif || "-"}
                              </small>
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">view details</span>
                            <span
                              className="value icon"
                              onClick={() =>
                                setModValues((prevs) => ({
                                  ...prevs,
                                  isModOpen: true,
                                  modName: "view_details",
                                  rowData: row,
                                  from: "recurring",
                                }))
                              }
                            >
                              <EyeIcon />
                            </span>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </div>
            </div>
          );
        })}

      <div className="lead-logs-card-pagination">
        <PaginationModified
          isPage={isPage}
          onChangePage={setIsPage}
          pagination={getPagination()}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      </div>
    </div>
  );
};

export default RecurringSubsListingsMobile;
